// NPM
import React, { Component } from 'react';

// Components
import DesktopNavbar from './DesktopNavbar';
import MobileNavbar from './MobileNavbar';

class Header extends Component {
  render() {
    return (
      <header className="Header-holder">
        <DesktopNavbar />
        <MobileNavbar />
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Components/Layout/Header.js